import { render, staticRenderFns } from "./AcceptingNewClientsPicker.vue?vue&type=template&id=683570d0&scoped=true&"
import script from "./AcceptingNewClientsPicker.vue?vue&type=script&lang=js&"
export * from "./AcceptingNewClientsPicker.vue?vue&type=script&lang=js&"
import style0 from "./AcceptingNewClientsPicker.vue?vue&type=style&index=0&id=683570d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683570d0",
  null
  
)

export default component.exports